import { Flex, Box, useTheme } from '@vitvio/design-system';
import { Suspense } from 'react';
import { LayoutTopbar } from './LayoutTopbar';
import { LayoutSidebar } from './LayoutSidebar';
import { LayoutFooter } from './LayoutFooter';
import { ConnectionLossBanner, useConnectionStatus } from '@vitvio/connection-provider';

interface LayoutProps {
  topbarHeader?: React.ReactNode;
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  isInDemoMode?: boolean;
  appName: 'platform' | 'recording-console';
}

export function Layout({ topbarHeader, children, sidebar, isInDemoMode, appName }: LayoutProps) {
  const { getColor, getRadius, getSpacing } = useTheme();
  const { isConnected } = useConnectionStatus();

  return (
    <Flex bg={getColor('bg.sunken')} p={'8px 0 0'} flexDir={'column'} overflow={'hidden'} height="100vh">
      <LayoutTopbar isInDemoMode={isInDemoMode}>{topbarHeader}</LayoutTopbar>
      <Flex overflow={'hidden'} flex={6} pb={!isConnected ? getSpacing('24') : undefined}>
        <LayoutSidebar>{sidebar}</LayoutSidebar>
        <Box
          flex={1}
          borderRadius={getRadius('2xl')} // all child components should have borderRadius set to 'inherit'
          bg={getColor('bg')}
          m={'8px 16px 0 8px'}
        >
          <Suspense>{children}</Suspense>
        </Box>
      </Flex>
      <LayoutFooter />
      <ConnectionLossBanner />
    </Flex>
  );
}
